

const SET_TOTAL_CONTATO = (state,total_contato) => {
	state.total_contato = total_contato
}

const SET_TOTAL_PROCEDIMENTO = (state,total_procedimento) => {
	state.total_procedimento = total_procedimento
}

const SET_CREDENCIADA = (state,credenciada) => {
	state.logged = credenciada
}

export{
	SET_TOTAL_CONTATO,
	SET_TOTAL_PROCEDIMENTO,
	SET_CREDENCIADA
}



// WEBPACK FOOTER //
// ./src/store/credenciada/mutations.js